import { trigger, transition, style, animate, query } from '@angular/animations';

/**
 * @description Анимация для выдвижения контента вверх
 */
export const fadeInOutUpAnimation = trigger('fadeInOutUpAnimation', [
  transition('* => *', [
    query(':enter', [
      style({ opacity: 0, transform: 'translateY(16px)' }),
      animate('0.250s', style({ opacity: 1, transform: 'translateY(0)' })),
    ], { optional: true }),
    query(':leave', [
      style({ opacity: 1, transform: 'translateY(0)' }),
      animate('0.250s', style({ opacity: 0, transform: 'translateY(16px)' })),
    ], { optional: true }),
  ]),
]);

/**
 * @description Анимация для появления контента
 */
export const fadeInOutAnimation = trigger('fadeInOutAnimation', [
  transition('* => *', [
    query(':enter', [
      style({ opacity: 0, transform: 'translateX(100%)' }),
      animate('0.150s', style({ opacity: 1, transform: 'translateX(0)' })),
    ], { optional: true }),
    query(':leave', [
      style({ opacity: 1, transform: 'translateX(0)' }),
      animate('0.150s', style({ opacity: 0, transform: 'translateX(100%)'})),
    ], { optional: true }),
  ]),
]);
